import React from 'react';

const Header = ({ title, tagline }) => {
    return (
        <div className="admin-header">
            <h1 className="header-title">{title}</h1>
            <p className="header-tagline">{tagline}</p>
        </div>
    );
};

export default Header;
